import './styles.css';
import BIGGBYLogo from './logo.svg';
import android from './android.svg';
import ios from './apple.svg';
import squiggle from './squiggle.svg';

export const Home = (): JSX.Element => {
	return (
		<div className="main grid">
			<div className="grid-item">
				<div className="column content">
					<img
						className="logo"
						src={BIGGBYLogo}
						alt="BIGGBY© COFFEE"
					/>
					<h1 className="header">Download the mobile app!</h1>
				</div>
				<div className="column">
					<div className="spacer"></div>
					<div className="row buttons">
						<div className="button">
							<a href="https://apps.apple.com/us/app/biggby/id907566791">
								<img className="button" src={ios} />
							</a>
						</div>
						<div className="button">
							<a href="https://play.google.com/store/apps/details?id=com.biggby.app">
								<img className="button" src={android} />
							</a>
						</div>
					</div>
				</div>
			</div>
			<div className="grid-item art">
				<img className="squiggle" src={squiggle} />
			</div>
			<div className="grid-item footer">
				<p className="footer-text">
					2026 BIGGBY® COFFEE All rights reserved. BIGGBY® and the
					orange rectangle B logo are registered trademarks of Global
					Orange Development, LLC
				</p>
			</div>
		</div>
	);
};

export default Home;
